import React from "react";
import {
  FACEBOOK_ACCOUNTS_SIDE_MODAL_RIGHT,
  INSTAGRAM_BIND_MODAL,
  LINKED_IN_ACCOUNTS_SIDE_MODAL_RIGHT,
} from "../../../constants/modal.constant";
import {
  FACEBOOK_ADS_SYNC_LOADING,
  FACEBOOK_SYNC_LOADING,
  INSTAGRAM_SYNC_LOADING,
  LINKED_IN_BUSINESS_SYNC_LOADING,
} from "../../../constants/loading.constant";
import { useGlobalCore } from "../../../cores/globals";
import SideModal from "../../layout/SideModal";

/**
 * Tras OAuth, FacebookAuthButton / Instagram / LinkedIn Business llaman a `turnOnModal`
 * con estos ids. Solo se muestran si algún layout monta este bloque (p. ej. Integraciones).
 * Sin esto, el modal queda “huérfano” y parece que solo funciona en la página de redes.
 */
export function SocialConnectAccountSideModals() {
  const {
    isModal,
    turnOffModal,
    getModalContent,
    getModalVisibility,
    turnOffLoading,
  } = useGlobalCore();

  return (
    <>
      <SideModal
        active={isModal(INSTAGRAM_BIND_MODAL)}
        visible={getModalVisibility(INSTAGRAM_BIND_MODAL)}
        onClose={() => {
          turnOffModal(INSTAGRAM_BIND_MODAL);
          turnOffLoading(INSTAGRAM_SYNC_LOADING);
        }}
      >
        {getModalContent(INSTAGRAM_BIND_MODAL)}
      </SideModal>
      <SideModal
        active={isModal(FACEBOOK_ACCOUNTS_SIDE_MODAL_RIGHT)}
        visible={getModalVisibility(FACEBOOK_ACCOUNTS_SIDE_MODAL_RIGHT)}
        onClose={() => {
          turnOffModal(FACEBOOK_ACCOUNTS_SIDE_MODAL_RIGHT);
          turnOffLoading(FACEBOOK_SYNC_LOADING);
          turnOffLoading(FACEBOOK_ADS_SYNC_LOADING);
        }}
      >
        {getModalContent(FACEBOOK_ACCOUNTS_SIDE_MODAL_RIGHT)}
      </SideModal>
      <SideModal
        active={isModal(LINKED_IN_ACCOUNTS_SIDE_MODAL_RIGHT)}
        visible={getModalVisibility(LINKED_IN_ACCOUNTS_SIDE_MODAL_RIGHT)}
        onClose={() => {
          turnOffModal(LINKED_IN_ACCOUNTS_SIDE_MODAL_RIGHT);
          turnOffLoading(LINKED_IN_BUSINESS_SYNC_LOADING);
        }}
      >
        {getModalContent(LINKED_IN_ACCOUNTS_SIDE_MODAL_RIGHT)}
      </SideModal>
    </>
  );
}
